import { Route, Routes, useLocation } from "react-router-dom";
import Connexion from "../pages/Layout/Connexion";
import Error from "../pages/Layout/Error";
import ResetPassword from "../pages/Layout/ResetPassword";
import CustomerRequests from "../pages/Cac/Customer/CustomerRequests";
import PartnerHomeCustomer from "../pages/Cac/Partner/PartnerHomeCustomer";
import PartnerMissions from "../pages/Cac/Partner/PartnerMissions";
import PartnerRequests from "../pages/Cac/Partner/PartnerRequests";
import RecoveryFile from "../pages/Cac/Partner/RecoveryFile";
import PartnerMonitoring from "../pages/Cac/Partner/PartnerMonitoring";
import RedirectToError from "../components/Layout/RedirectToError";
import AdminPartner from "../pages/Admin/AdminPartner";
import AdminCustomer from "../pages/Admin/AdminCustomer";
import AdminClientFile from "../pages/Admin/AdminClientFile";
import AdminMission from "../pages/Admin/AdminMission";
import PartnerMonitoringMission from "../pages/Cac/Partner/PartnerMonitoringMission";
import SuperAdminHome from "../pages/SuperAdmin/SuperAdminHome";
import AdminCategories from "../pages/Admin/AdminCategories";
import CGU from "../pages/Informations/CGU";
import LegalNotice from "../pages/Informations/LegalNotice";
import CookiesNotice from "../pages/Informations/CookiesNotice";
import CustomerHome from "../pages/Cac/Customer/CustomerHome";
import Dashboard from "../pages/Layout/Dashboard";
import { useTokenContext } from "../context/tokenContext";
import { useEffect } from "react";
import { useServiceStore } from "../stores/admin/service";
import { usePartnerRequestsStore2 } from "../stores/Cac/Partner/partnerRequests";
import CustomerWorkingFolder from "../pages/Cac/Customer/CustomerWorkingFolder";
import PartnerWorkingFolder from "../pages/Cac/Partner/PartnerWorkingFolder";
import { usePartnerMissionStore } from "../stores/Cac/Partner/partnerMission";
import { useRecoveryFileStore } from "../stores/Utils/recoveryFIle";
import CreateAnAccount from "../pages/Layout/CreateAnAccount";
import Profil from "../pages/Layout/Profil";
import ProtectedRoute from "./ProtectedRoute";
import AdminRelaunch from "../pages/Admin/AdminRelaunch";
import PartnerDocuments from "../pages/Cac/Partner/PartnerDocuments";

const AppRoutes = () => {
  const { setRoleId } =
    useTokenContext();
  const location = useLocation();
  const { setSearchTerm } = useServiceStore();
  const { setOpenDetails, setRequestId, setRequests } =
    usePartnerRequestsStore2();
  const { setMissions } = usePartnerMissionStore();
  const { resetSelect } = useRecoveryFileStore();

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setRoleId(0);
    }
    setSearchTerm("");

    if (!location.pathname.includes("requests")) {
      setRequestId(0);
      setOpenDetails(false);
      setRequests([]);
    }

    setMissions([]);
    resetSelect();
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Connexion />} />
        <Route path="/error" element={<Error />} />
        <Route path="/legalnotice" element={<LegalNotice />} />
        <Route path="/cookiesnotice" element={<CookiesNotice />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/workingfolder" element={<CustomerWorkingFolder />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/createaccount" element={<CreateAnAccount />} />

        {/* Superadmin Dashboard */}
        <Route
          path="/superadmin/dashboard"
          element={
            <ProtectedRoute requiredRole="SuperAdmin">
              <SuperAdminHome />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes */}
        <Route
          path="/partner/:idPartner/admin/users/partner"
          element={
            <ProtectedRoute requiredRole="Admin">
              <AdminPartner />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/admin/users/customer"
          element={
            <ProtectedRoute requiredRole="Admin">
              <AdminCustomer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/admin/relaunch"
          element={
            <ProtectedRoute requiredRole="Admin">
              <AdminRelaunch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/admin/clientfile"
          element={
            <ProtectedRoute requiredRole="Admin">
              <AdminClientFile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/admin/category"
          element={
            <ProtectedRoute requiredRole="Admin">
              <AdminCategories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/admin/mission"
          element={
            <ProtectedRoute requiredRole="Admin">
              <AdminMission />
            </ProtectedRoute>
          }
        />

        <Route
          path="/partner/:idPartner/customers/:idCustomer/workingfolder/:idWorkingFolder"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerWorkingFolder />
            </ProtectedRoute>
          }
        />
        {/* Dashboard - accessible par Admin, Partner et Customer */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Profil - accessible par Admin, Partner et Customer */}
        <Route
          path="/profil"
          element={
            <ProtectedRoute>
              <Profil />
            </ProtectedRoute>
          }
        />

        {/* Partner Routes */}
        <Route
          path="/partner/:idPartner/customers"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerHomeCustomer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/customers/:idCustomer/missions/:idMission/documents"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerDocuments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/monitoring/missions"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerMonitoringMission />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/customers/:idCustomer/missions"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerMissions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/customers/:idCustomer/missions/:idMission/requests"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerRequests />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/customers/:idCustomer/missions/:idMission/monitoring"
          element={
            <ProtectedRoute requiredRole="Partner">
              <PartnerMonitoring />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner/:idPartner/customers/:idCustomer/missions/:idMission/recoveryfile"
          element={
            <ProtectedRoute requiredRole="Partner">
              <RecoveryFile />
            </ProtectedRoute>
          }
        />

        {/* Customer Routes */}
        <Route
          path="/customer/:idCustomer/missions"
          element={
            <ProtectedRoute requiredRole="Customer">
              <CustomerHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/:idCustomer/missions/:idMission/requests"
          element={
            <ProtectedRoute requiredRole="Customer">
              <CustomerRequests />
            </ProtectedRoute>
          }
        />

        {/* Route catch-all DOIT être à la fin */}
        <Route path="*" element={<RedirectToError />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
